// Sugalarm — activation (delivery-readiness) API client, cycle 365.
//
// One call: post this install's capability report, get the server's
// verdict. Diagnostic only — a failure here changes nothing about alarm
// delivery, so every caller treats it as best-effort.

import { request } from "../lib/apiClient";
import type { ApiResult } from "../lib/types";
import type { ActivationReport, ActivationVerdict } from "../lib/activation";

export function reportActivation(
  body: ActivationReport,
): Promise<ApiResult<ActivationVerdict>> {
  return request<ActivationVerdict>("/api/push/native/activation", {
    method: "POST",
    body,
  });
}
